var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewbillinghistory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2000 2000",
    style: {
      enableBackground: "new 0 0 2000 2000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#F1F1F1;stroke:#060809;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#060809;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st3{fill:#E85350;stroke:#060809;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st4{fill:#FCD479;stroke:#060809;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st5{fill:#69C1C7;stroke:#060809;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 418.08,
    y: 403.8,
    className: "st0",
    width: 1192.92,
    height: 1192.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1354.68,879.02c-5.3,0-10.6,0.35-15.86,0.84c0-0.25,0.08-0.49,0.08-0.74 c0-157.54-127.69-285.21-285.25-285.21c-132.17,0-242.93,90.02-275.31,211.94c-15.95-3.74-32.47-5.96-49.44-5.96 c-118.15,0-213.87,95.76-213.87,213.95c0,118.07,95.71,213.83,213.87,213.83h29.3c-2.88-15.74-4.6-31.89-4.6-48.45 c0-148.28,120.17-268.44,268.4-268.44c148.28,0,268.44,120.17,268.44,268.44c0,16.56-1.73,32.71-4.6,48.45h68.84 c96.29,0,174.33-78.04,174.33-174.33C1529.01,957.13,1450.97,879.02,1354.68,879.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M768.47,879.12c0-25.4,3.66-49.87,9.86-73.28C772.13,829.25,768.47,853.72,768.47,879.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1290.45,1179.21c0,148.19-120.17,268.36-268.44,268.36c-148.24,0-268.4-120.17-268.4-268.36 c0-148.28,120.17-268.44,268.4-268.44C1170.28,910.77,1290.45,1030.93,1290.45,1179.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1253.13,1179.21c0,127.6-103.44,231.09-231.13,231.09c-127.65,0-231.13-103.48-231.13-231.09 c0-127.69,103.48-231.13,231.13-231.13C1149.69,948.08,1253.13,1051.52,1253.13,1179.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1051.84,1408.16v-258.79h-59.67v258.79c9.82,1.23,19.73,2.14,29.84,2.14 C1032.15,1410.3,1042.06,1409.44,1051.84,1408.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M962.37,1089.7H902.7v287.14c18.41,11.14,38.43,19.73,59.67,25.4V1089.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M813.23,1277.89c14.22,30,34.56,56.51,59.67,77.76v-116.8h-59.67V1277.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1230.77,1277.89v-98.71h-59.63v176.47C1196.21,1334.39,1216.55,1307.89,1230.77,1277.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1141.31,1030.07h-59.63v372.17c21.25-5.67,41.26-14.26,59.63-25.4V1030.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1354.72,879.12c-48.08,0-91.65,19.48-123.21,51.02C1263.08,898.6,1306.64,879.12,1354.72,879.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M701.4,940.6c0,20.59-16.68,37.28-37.28,37.28c-20.59,0-37.27-16.68-37.27-37.28 c0-20.59,16.68-37.27,37.27-37.27C684.72,903.33,701.4,920.01,701.4,940.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1029.44,731.83c0,20.59-16.69,37.29-37.28,37.29c-20.55,0-37.28-16.7-37.28-37.29 c0-20.57,16.73-37.28,37.28-37.28C1012.75,694.56,1029.44,711.26,1029.44,731.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1238.21,821.3c0,20.59-16.68,37.3-37.27,37.3c-20.59,0-37.28-16.71-37.28-37.3 c0-20.57,16.68-37.28,37.28-37.28C1221.53,784.02,1238.21,800.73,1238.21,821.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M552.3,1238.84c0,20.55-16.73,37.27-37.28,37.27c-20.59,0-37.28-16.73-37.28-37.27 c0-20.59,16.69-37.28,37.28-37.28C535.58,1201.57,552.3,1218.25,552.3,1238.84z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 1514.09,
    cy: 590.19,
    r: 37.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M531.63,1205.64l115.89-231.83L531.63,1205.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1230.85,799.25l253.36-187.01L1230.85,799.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M694.38,962.22l101.63,72.58L694.38,962.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1026.44,746.52l140.26,60.1L1026.44,746.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M980.45,767.05l-53.83,161.51L980.45,767.05z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewbillinghistory);
export default __webpack_public_path__ + "static/media/viewbillinghistory.b0b1c52154a68cc0e217fa7ad5e09de6.svg";
export { ForwardRef as ReactComponent };